import { useCallback, useEffect, useMemo, useRef } from 'react';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import {
  TRestoreAllTicketValidation,
  RestoreAllTicketValidationSchema,
  useRestoreAllTicketMutation,
} from '../../../api/restore-all-ticket.api';
import { useCustomToast } from '@/hooks/use-custom-toast';
import { axiosExtractErrorMessage, AxiosErrorCustom } from '@/lib/axios';
import { queryClient } from '@/lib/react-query';
import {
  GET_LIST_ARCHIVE_TICKET_BY_SPACE_QUERY_KEY,
  TGetListArchiveTicketBySpaceResponse,
} from '../../../api/get-archive-ticket-by-space.api';
import {
  GET_LIST_TICKET_BY_SPACE_QUERY_KEY,
  TGetListTicketBySpaceResponse,
} from '../../../api/get-ticket-by-space.api';
import { useTicketingModalRootActions } from '@/features/ticketings/_shared/components/ticketing-modal-root/ticketing-modal-root.store';
import { spaceUpdateWebsocketStore } from '@/features/ticketings/_shared/websockets/space-update-websocket.store';
import { TTicketBySpace } from '../../../types/ticket.type';
import { sortTicketsByPosition } from '../../../utils/ordering-ticket.utils';

const COLUMN_RESTORE_TIMEOUT = 800;

export interface IRestoreAllTicketModalProps {
  spaceId: string;
  spaceColumnId: string;
  onSuccess?: () => Promise<void> | void;
}

interface IRestoreAllTicketOptimisticContext {
  previousArchiveData?: TGetListArchiveTicketBySpaceResponse;
  previousActiveData?: TGetListTicketBySpaceResponse;
  restoredTickets?: TTicketBySpace['tickets'];
  restoredColumn?: TTicketBySpace;
}

export function useRestoreAllTicketModal({ spaceId, spaceColumnId, onSuccess }: IRestoreAllTicketModalProps) {
  // HOOKS
  const showToast = useCustomToast();
  const modalActions = useTicketingModalRootActions();

  // Ref to track timeout for cleanup
  const closeModalTimeoutRef = useRef<NodeJS.Timeout | null>(null);

  const archiveQueryKey = [GET_LIST_ARCHIVE_TICKET_BY_SPACE_QUERY_KEY, { spaceId }];
  const activeQueryKey = [GET_LIST_TICKET_BY_SPACE_QUERY_KEY, { spaceId }];

  const mutationRestoreAllTicket = useRestoreAllTicketMutation({
    mutationConfig: {
      onMutate: async (variables: TRestoreAllTicketValidation): Promise<void> => {
        // Set restoring state for this column
        const { actions } = spaceUpdateWebsocketStore.getState();
        actions.setColumnOperation(variables.spaceColumnId, 'restoring');

        // // Cancel any outgoing refetches to avoid overwriting optimistic update
        // await Promise.all([
        //   queryClient.cancelQueries({ queryKey: archiveQueryKey }),
        //   queryClient.cancelQueries({ queryKey: activeQueryKey }),
        // ]);

        // // Snapshot the previous values for rollback
        // const previousArchiveData = queryClient.getQueryData<TGetListArchiveTicketBySpaceResponse>(archiveQueryKey);
        // const previousActiveData = queryClient.getQueryData<TGetListTicketBySpaceResponse>(activeQueryKey);

        // // Find the column and get all tickets from archive
        // let restoredTickets: TTicketBySpace['tickets'] | undefined;
        // let restoredColumn: TTicketBySpace | undefined;

        // if (previousArchiveData?.payload) {
        //   const archiveColumn = previousArchiveData.payload.find((col) => col.spaceColumnId === spaceColumnId);
        //   if (archiveColumn) {
        //     restoredTickets = archiveColumn.tickets || [];
        //     restoredColumn = {
        //       spaceColumnId: archiveColumn.spaceColumnId,
        //       name: archiveColumn.name,
        //       columnIndex: archiveColumn.columnIndex,
        //       color: archiveColumn.color,
        //       tickets: [],
        //     };
        //   }
        // }

        // // Optimistically remove all tickets from archive list
        // if (previousArchiveData?.payload && restoredTickets && restoredColumn) {
        //   queryClient.setQueryData<TGetListArchiveTicketBySpaceResponse>(archiveQueryKey, (old) => {
        //     if (!old?.payload) return old;

        //     return {
        //       ...old,
        //       payload: old.payload.map((column) => {
        //         if (column.spaceColumnId === spaceColumnId) {
        //           return {
        //             ...column,
        //             tickets: [],
        //           };
        //         }
        //         return column;
        //       }),
        //     };
        //   });
        // }

        // // Optimistically add all tickets back to active list
        // if (previousActiveData?.payload && restoredTickets && restoredColumn) {
        //   queryClient.setQueryData<TGetListTicketBySpaceResponse>(activeQueryKey, (old) => {
        //     if (!old?.payload) return old;

        //     // Find the column in active list
        //     const targetColumnIndex = old.payload.findIndex((col) => col.spaceColumnId === spaceColumnId);

        //     if (targetColumnIndex >= 0) {
        //       // Column exists, restore all tickets to it
        //       const newPayload = [...old.payload];
        //       const targetColumn = newPayload[targetColumnIndex];
        //       const sortedTickets = sortTicketsByPosition(restoredTickets);

        //       newPayload[targetColumnIndex] = {
        //         ...targetColumn,
        //         tickets: [...sortedTickets],
        //       };
        //       return {
        //         ...old,
        //         payload: newPayload,
        //       };
        //     } else {
        //       // Column doesn't exist in active list, create it with all restored tickets
        //       const sortedTickets = sortTicketsByPosition(restoredTickets);
        //       return {
        //         ...old,
        //         payload: [
        //           ...old.payload,
        //           {
        //             ...restoredColumn,
        //             tickets: sortedTickets,
        //           },
        //         ],
        //       };
        //     }
        //   });
        // }

        // return {
        //   previousArchiveData,
        //   previousActiveData,
        //   restoredTickets,
        //   restoredColumn,
        // };
      },
      //   // Cancel any outgoing refetches to avoid overwriting optimistic update
      //   await Promise.all([
      //     queryClient.cancelQueries({ queryKey: archiveQueryKey }),
      //     queryClient.cancelQueries({ queryKey: activeQueryKey }),
      //   ]);

      //   // Snapshot the previous values for rollback
      //   const previousArchiveData = queryClient.getQueryData<TGetListArchiveTicketBySpaceResponse>(archiveQueryKey);
      //   const previousActiveData = queryClient.getQueryData<TGetListTicketBySpaceResponse>(activeQueryKey);

      //   // Find the column and get all tickets from archive
      //   let restoredTickets: TTicketBySpace['tickets'] | undefined;
      //   let restoredColumn: TTicketBySpace | undefined;

      //   if (previousArchiveData?.payload) {
      //     const archiveColumn = previousArchiveData.payload.find((col) => col.spaceColumnId === spaceColumnId);
      //     if (archiveColumn) {
      //       restoredTickets = archiveColumn.tickets || [];
      //       restoredColumn = {
      //         spaceColumnId: archiveColumn.spaceColumnId,
      //         name: archiveColumn.name,
      //         columnIndex: archiveColumn.columnIndex,
      //         color: archiveColumn.color,
      //         tickets: [],
      //       };
      //     }
      //   }

      //   // Optimistically remove all tickets from archive list
      //   if (previousArchiveData?.payload && restoredTickets && restoredColumn) {
      //     queryClient.setQueryData<TGetListArchiveTicketBySpaceResponse>(archiveQueryKey, (old) => {
      //       if (!old?.payload) return old;

      //       return {
      //         ...old,
      //         payload: old.payload.map((column) => {
      //           if (column.spaceColumnId === spaceColumnId) {
      //             return {
      //               ...column,
      //               tickets: [],
      //             };
      //           }
      //           return column;
      //         }),
      //       };
      //     });
      //   }

      //   // Optimistically add all tickets back to active list
      //   if (previousActiveData?.payload && restoredTickets && restoredColumn) {
      //     queryClient.setQueryData<TGetListTicketBySpaceResponse>(activeQueryKey, (old) => {
      //       if (!old?.payload) return old;

      //       // Find the column in active list
      //       const targetColumnIndex = old.payload.findIndex((col) => col.spaceColumnId === spaceColumnId);

      //       if (targetColumnIndex >= 0) {
      //         // Column exists, restore all tickets to it
      //         const newPayload = [...old.payload];
      //         const targetColumn = newPayload[targetColumnIndex];
      //         const sortedTickets = sortTicketsByPosition(restoredTickets);

      //         newPayload[targetColumnIndex] = {
      //           ...targetColumn,
      //           tickets: [...sortedTickets],
      //         };
      //         return {
      //           ...old,
      //           payload: newPayload,
      //         };
      //       } else {
      //         // Column doesn't exist in active list, create it with all restored tickets
      //         const sortedTickets = sortTicketsByPosition(restoredTickets);
      //         return {
      //           ...old,
      //           payload: [
      //             ...old.payload,
      //             {
      //               ...restoredColumn,
      //               tickets: sortedTickets,
      //             },
      //           ],
      //         };
      //       }
      //     });
      //   }

      //   return {
      //     previousArchiveData,
      //     previousActiveData,
      //     restoredTickets,
      //     restoredColumn,
      //   };
      // },
      onError: (error: AxiosErrorCustom, variables: TRestoreAllTicketValidation, context: unknown) => {
        // Clear restoring state on error
        const { actions } = spaceUpdateWebsocketStore.getState();
        actions.clearColumnOperation(variables.spaceColumnId);

        const errorMessage = axiosExtractErrorMessage(error) || 'Error restore all tickets, please try again';
        showToast({ message: errorMessage, type: 'error' });

        // // Rollback to previous data on error
        // if (context && typeof context === 'object' && 'previousArchiveData' in context) {
        //   const typedContext = context as IRestoreAllTicketOptimisticContext;
        //   if (typedContext.previousArchiveData !== undefined) {
        //     queryClient.setQueryData(archiveQueryKey, typedContext.previousArchiveData);
        //   }
        //   if (typedContext.previousActiveData !== undefined) {
        //     queryClient.setQueryData(activeQueryKey, typedContext.previousActiveData);
        //   }
        // }
      },
      onSuccess: async () => {
        showToast({ message: 'All tickets restored successfully!', type: 'success' });

        // Wait a bit before closing modal to ensure backend has processed the request
        // The socket listener will handle clearing the state after queries are invalidated
        await new Promise<void>((resolve) => {
          // Clear any existing timeout
          if (closeModalTimeoutRef.current) {
            clearTimeout(closeModalTimeoutRef.current);
          }

          // Set new timeout and store the ID for cleanup
          closeModalTimeoutRef.current = setTimeout(() => {
            // Check if modal is still open before closing
            if (modalActions.checkIsOpenModal('RestoreAllTicketModal')) {
              modalActions.closeModal('RestoreAllTicketModal');
              form.reset();

              // Call the onSuccess callback if provided
              if (onSuccess) {
                onSuccess();
              }
            }

            closeModalTimeoutRef.current = null;
            resolve();
          }, COLUMN_RESTORE_TIMEOUT);
        });

        // Note: We don't clear the column operation state here
        // The socket listener (handleColumnRestored) will clear it after
        // invalidating queries and ensuring data is fresh
      },
    },
  });

  const form = useForm<TRestoreAllTicketValidation>({
    resolver: zodResolver(RestoreAllTicketValidationSchema),
    mode: 'onChange',
    defaultValues: {
      spaceColumnId: '',
    },
  });

  // HELPERS
  /*
    Separate loading form and loading mutation
   */
  const isOpen = useMemo(() => {
    return modalActions.checkIsOpenModal('RestoreAllTicketModal');
  }, [modalActions]);

  const isDisabledForm = useMemo(() => {
    return mutationRestoreAllTicket.isPending || form.formState.isSubmitting;
  }, [mutationRestoreAllTicket, form.formState.isSubmitting]);

  const isLoadingForm = useMemo(() => {
    return mutationRestoreAllTicket.isPending || form.formState.isSubmitting;
  }, [mutationRestoreAllTicket, form.formState.isSubmitting]);

  // EFFECTS
  useEffect(() => {
    if (spaceColumnId) {
      form.reset({
        spaceColumnId: spaceColumnId,
      });
    }
  }, [spaceColumnId, form]);

  // Cleanup timeout on unmount or when modal closes
  useEffect(() => {
    return () => {
      if (closeModalTimeoutRef.current) {
        clearTimeout(closeModalTimeoutRef.current);
        closeModalTimeoutRef.current = null;
      }
    };
  }, []);

  // Cleanup timeout when modal closes
  useEffect(() => {
    if (!isOpen && closeModalTimeoutRef.current) {
      clearTimeout(closeModalTimeoutRef.current);
      closeModalTimeoutRef.current = null;
    }
  }, [isOpen]);

  // HANDLERS
  const handleCloseModal = useCallback(() => {
    modalActions.closeModal('RestoreAllTicketModal');
  }, [modalActions]);

  const handleCancelModal = useCallback(() => {
    handleCloseModal();
  }, [handleCloseModal]);

  const handleSubmitForm = useCallback(
    (data: TRestoreAllTicketValidation) => {
      mutationRestoreAllTicket.mutate({
        spaceColumnId: data?.spaceColumnId,
      });
    },
    [mutationRestoreAllTicket]
  );

  return {
    // FORM
    form,
    isOpen,
    isDisabledForm,
    isLoadingForm,

    // HANDLERS
    handleCancelModal,
    handleCloseModal,
    handleSubmitForm,
  };
}
